import Vue from 'vue';

export default {
  // 银行卡列表
  getBankList() {
    return Vue.axios.get('/api/v1.0/bankCard/selectAccountListByUserId');
  },
  // 更换银行卡
  updateSignBank(params) {
    return Vue.axios.get('/api/v1.0/chanquan/bid/updateSignBank', { params });
  }
};
